"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FilesService = /** @class */ (function () {
    function FilesService() {
    }
    FilesService.setFile = function (file, hash) {
        var wwFile = {
            hash: hash,
            file: file
        };
        if (!FilesService.existsFile(wwFile)) {
            FilesService.storage.push(wwFile);
        }
    };
    FilesService.removeFile = function (hash) {
        var file = FilesService.storage.filter(function (wwFile) { return wwFile.hash === hash; });
        if (file.length === 0)
            return;
        FilesService.storage = FilesService.storage.filter(function (wwFile) { return wwFile.hash !== hash; });
    };
    FilesService.getFiles = function () {
        return (FilesService.storage || []);
    };
    FilesService.getFilesAsDataTransfer = function () {
        var dataTransfer = new DataTransfer();
        for (var _i = 0, _a = FilesService.storage; _i < _a.length; _i++) {
            var wwFile = _a[_i];
            dataTransfer.items.add(wwFile.file);
        }
        return dataTransfer;
    };
    FilesService.existsFile = function (file) {
        return (FilesService.storage.filter(function (wwFile) { return wwFile.hash === file.hash; }).length > 0);
    };
    FilesService.storage = [];
    return FilesService;
}());
exports.default = FilesService;
